import { Link } from "react-router-dom";

/** Shared shell for the Terms + Privacy pages — matches Vowze's Apple-style look. */
export default function LegalShell({ title, updated, children }) {
    return (
        <div className="min-h-screen bg-ivory pb-24 pt-14 text-charcoal" data-testid={`legal-page-${title.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="mx-auto max-w-3xl px-6">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-charcoal/60 transition hover:text-charcoal"
                    data-testid="legal-back-home"
                >
                    ← Vowze
                </Link>
                <h1 className="mt-6 font-serif text-4xl leading-tight md:text-5xl">{title}</h1>
                {updated && (
                    <p className="mt-2 text-[11px] uppercase tracking-[0.22em] text-charcoal/50">
                        Last updated · {updated}
                    </p>
                )}
                <div className="prose prose-charcoal mt-10 max-w-none text-[14px] leading-relaxed text-ink [&_h2]:mt-10 [&_h2]:font-serif [&_h2]:text-[22px] [&_h2]:leading-tight [&_h2]:text-charcoal [&_h3]:mt-6 [&_h3]:font-serif [&_h3]:text-[16px] [&_h3]:text-charcoal [&_p]:mt-3 [&_ul]:ml-5 [&_ul]:list-disc [&_ul_li]:mt-1.5 [&_a]:underline">
                    {children}
                </div>
                <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-charcoal/10 pt-6 text-[12px] text-charcoal/55">
                    <span>© {new Date().getFullYear()} Vowze — a personal styling tool. Not a legal advisory service.</span>
                    <div className="flex gap-4">
                        <Link to="/terms" className="hover:text-charcoal">Terms</Link>
                        <Link to="/privacy" className="hover:text-charcoal">Privacy</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
